import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Char19o2r8palgjof as Char } from '../Char.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function appendElement(_this__u8e3s4, element, transform) {
  if (!(transform == null))
    _this__u8e3s4.x1(transform(element));
  else {
    if (element == null ? true : isCharSequence(element))
      _this__u8e3s4.x1(element);
    else {
      if (element instanceof Char())
        _this__u8e3s4.o1(element.f4_1);
      else {
        _this__u8e3s4.x1(toString(element));
      }
    }
  }
}
//region block: exports
export {
  appendElement as appendElement7nmjunfw9r4,
};
//endregion

//# sourceMappingURL=Appendable.mjs.map
